// import React, { useEffect, useState } from 'react';
// import client from '../../sanity/client';
// import { useLanguage } from '../../components/LanguageContext';
// import { Link } from 'react-router-dom';
// import { PlusIcon, ArrowRight } from '../../assets/svg';
// import './Veilleuse.scss';

// const Veilleuse = () => {
//   const [data, setData] = useState(null);
//   const { language } = useLanguage();

//   useEffect(() => {
//     const fetchData = async () => {
//       // Récupère le document poeteSections et ses deux tableaux
//       const query = `*[_type == "poeteSections"][0]{
//         veilleuse[]{
//           _key,
//           title,
//           "slug": slug.current,
//           description,
//           image,
//           gallery[]{ "imageUrl": asset->url + "?auto=format" }
//         }
//       }`;
//       const result = await client.fetch(query);
//       setData(result);
//     };

//     fetchData();
//   }, []);

//   if (!data) return <div>Loading...</div>;

//   // Extrait les sections
//   const veilleuseSection = data.veilleuse;

//   return (
//     <div className="oeuvre-page">
//       {/* Section Veilleuse de lieux */}
//       <section id="veilleusedelieux">
//         <h1>veilleuse de lieux</h1>
//         <div className="works-list">
//           {veilleuseSection && veilleuseSection.map((item) => (
//             <div key={item._key} className="work-item">
//               <Link to={`/poete/veilleusedelieux/${item.slug}`} className="work-header hover-icon-transition">
//                 <h2>{item.title}</h2>
//                 <span className="icon-wrapper">
//                   <span className="plus-icon"><PlusIcon /></span>
//                   <span className="arrow-icon"><ArrowRight /></span>
//                 </span>
//               </Link>
//             </div>
//           ))}
//         </div>
//       </section>

//     </div>
//   );
// };

// export default Veilleuse;

import React, { useEffect, useState } from 'react';
import client from '../../sanity/client';
import { useLanguage } from '../../components/LanguageContext';
import { PlusIcon, ArrowRight } from '../../assets/svg';
import useScrollPosition from '../../hooks/useScrollPosition';
import useSectionNavigation from '../../hooks/useSectionNavigation';
import './Veilleuse.scss';

const Veilleuse = () => {
  const [data, setData] = useState(null);
  const [sectionTitle, setSectionTitle] = useState(null);
  const { language } = useLanguage();
  
  // Hooks pour gérer la position de scroll et navigation
  useScrollPosition();
  const { navigateToDetail } = useSectionNavigation();

  useEffect(() => {
    const fetchData = async () => {
      // Récupère le document poeteSections avec les titres multilingues
      const query = `*[_type == "poeteSections"][0]{
        sectionTitle,
        veilleuse[]{
          _key,
          title,
          "slug": slug.current,
          description,
          link{
            url,
            text
          },
          image,
          gallery[]{ "imageUrl": asset->url + "?auto=format" }
        }
      }`;
      const result = await client.fetch(query);
      setData(result);
      setSectionTitle(result?.sectionTitle);
    };

    fetchData();
  }, []);

  // Fonction helper pour gérer les titres multilingues
  const getSafeTitle = (titleObj) => {
    if (!titleObj) return 'Titre par défaut';
    if (typeof titleObj === 'string') return titleObj; // Compatibilité ancien format
    return titleObj[language] || titleObj.fr || titleObj.en || 'Titre';
  };

  if (!data) return <div>Loading...</div>;

  // Extrait les sections
  const veilleuseSection = data.veilleuse;

  return (
    <div className="oeuvre-page">
      {/* Section Résidences */}
      <section id="résidences">
        <h1>
          {sectionTitle?.[language] || sectionTitle?.fr || sectionTitle?.en || 'résidences'}
        </h1>
        <div className="works-list">
          {veilleuseSection && veilleuseSection.map((item) => (
            <div key={item._key} className="work-item">
              <a 
                href="#"
                className="work-header hover-icon-transition"
                onClick={(e) => {
                  e.preventDefault();
                  navigateToDetail(`/veilleusedelieux/résidences/${item.slug}`, 'résidences');
                }}
              >
                <h2>{getSafeTitle(item.title)}</h2>
                <span className="icon-wrapper">
                  <span className="plus-icon"><PlusIcon /></span>
                  <span className="arrow-icon"><ArrowRight /></span>
                </span>
              </a>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Veilleuse;
